
export const ADD_PRINT_REQUEST= "ADD_PRINT_REQUEST"
export const ADD_PRINT_REQUEST_SUCCESS = "ADD_PRINT_REQUEST_SUCCESS"
export const ADD_PRINT_REQUEST_FAIL = "ADD_PRINT_REQUEST_FAIL"

export const GET_PRINTER_FROM_PRODUCT= "GET_PRINTER_FROM_PRODUCT"
export const GET_PRINTER_FROM_PRODUCT_SUCCESS = "GET_PRINTER_FROM_PRODUCT_SUCCESS"
export const GET_PRINTER_FROM_PRODUCT_FAIL = "GET_PRINTER_FROM_PRODUCT_FAIL"


export const GET_PRINTING_REQUESTS_USER_ID= "GET_PRINTING_REQUESTS_USER_ID"
export const GET_PRINTING_REQUESTS_USER_ID_SUCCESS = "GET_PRINTING_REQUESTS_USER_ID_SUCCESS"
export const GET_PRINTING_REQUESTS_USER_ID_FAIL = "GET_PRINTING_REQUESTS_USER_ID_FAIL"


export const GET_PRINTING_REQUESTS_OWNER_ID= "GET_PRINTING_REQUESTS_OWNER_ID"
export const GET_PRINTING_REQUESTS_OWNER_ID_SUCCESS = "GET_PRINTING_REQUESTS_OWNER_ID_SUCCESS"
export const GET_PRINTING_REQUESTS_OWNER_ID_FAIL = "GET_PRINTING_REQUESTS_OWNER_ID_FAIL"

export const ADD_PRINT_TRANS= "ADD_PRINT_TRANS"
export const ADD_PRINT_TRANS_SUCCESS = "ADD_PRINT_TRANS_SUCCESS"
export const ADD_PRINT_TRANS_FAIL = "ADD_PRINT_TRANS_FAIL"

export const ADD_ARTWORK_FORM= "ADD_ARTWORK_FORM"
export const ADD_ARTWORK_FORM_SUCCESS = "ADD_ARTWORK_FORM_SUCCESS"
export const ADD_ARTWORK_FORM_FAIL = "ADD_ARTWORK_FORM_FAIL"


export const GET_ARTWORK_FORM= "GET_ARTWORK_FORM"
export const GET_ARTWORK_FORM_SUCCESS = "GET_ARTWORK_FORM_SUCCESS"
export const GET_ARTWORK_FORM_FAIL = "GET_ARTWORK_FORM_FAIL"


export const GET_PRINTER_LIST= "GET_PRINTER_LIST"
export const GET_PRINTER_LIST_SUCCESS = "GET_PRINTER_LIST_SUCCESS"
export const GET_PRINTER_LIST_FAIL = "GET_PRINTER_LIST_FAIL"



export const GET_CHECK_INTENT= "GET_CHECK_INTENT"
export const GET_CHECK_INTENT_SUCCESS = "GET_CHECK_INTENT_SUCCESS"
export const GET_CHECK_INTENT_FAIL = "GET_CHECK_INTENT_FAIL"



export const WITHDRAW_REQUEST_SELLER= "WITHDRAW_REQUEST_SELLER"
export const WITHDRAW_REQUEST_SELLER_SUCCESS = "WITHDRAW_REQUEST_SELLER_SUCCESS"
export const WITHDRAW_REQUEST_SELLER_FAIL = "WITHDRAW_REQUEST_SELLER_FAIL"



export const PRINT_REQUEST_TRANS= "PRINT_REQUEST_TRANS"
export const PRINT_REQUEST_TRANS_SUCCESS = "PRINT_REQUEST_TRANS_SUCCESS"
export const PRINT_REQUEST_TRANS_FAIL = "PRINT_REQUEST_TRANS_FAIL"


export const VERIFY_DEALER_CODE= "VERIFY_DEALER_CODE"
export const VERIFY_DEALER_CODE_SUCCESS = "VERIFY_DEALER_CODE_SUCCESS"
export const VERIFY_DEALER_CODE_FAIL = "VERIFY_DEALER_CODE_FAIL"


export const GET_PAYMENT_INTENT= "GET_PAYMENT_INTENT"
export const GET_PAYMENT_INTENT_SUCCESS = "GET_PAYMENT_INTENT_SUCCESS"
export const GET_PAYMENT_INTENT_FAIL = "GET_PAYMENT_INTENT_FAIL"

export const GET_PRINTER_BY_COUNTRY= "GET_PRINTER_BY_COUNTRY"
export const GET_PRINTER_BY_COUNTRY_SUCCESS = "GET_PRINTER_BY_COUNTRY_SUCCESS"
export const GET_PRINTER_BY_COUNTRY_FAIL = "GET_PRINTER_BY_COUNTRY_FAIL"

